import React, {useCallback, useEffect, useReducer, useState} from "react";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button"
import Table, {TableCell, TableRow} from "@amzn/meridian/table"
import {DriverListReducer} from "../storeReconciliationSheet/reducers/DriverListReducer";
import Loader from "@amzn/meridian/loader";
import RadioButton from "@amzn/meridian/radio-button";
import Alert from "@amzn/meridian/alert";
import Column from "@amzn/meridian/column";
import Pagination from "@amzn/meridian/pagination";
import {FormattedMessage} from "react-intl";
import {VirtualDepartDriverDialog} from "./VirtualDepartDriverDialog";
import SearchField from "@amzn/meridian/search-field";
import VirtualDepartDriverContextProvider from "./context/VirtualDepartDriverContext";
import {FeatureConstants} from "../constants/FeatureConstants";
import {useFeatures} from "../handler/DynamicConfigHandler";

const DRIVER_ATTRIBUTES = [
    ["DRIVER_NAME", {stringId: "tracking_id"}],
    ["DRIVER_ID", {stringId: "shipment_type"}],
    ["IS_STORE", {stringId: "store"}],
];

const PAGE_SIZE = 100;

const initialState = {
    drivers: [],
    filterDrivers: [],
    loading: false,
    success: true
};

const driverDetailInitialState = {
    driverName: "",
    driverId: "",
    storeId: "",
    isStore: false
};
export const VirtualDepartDriver = (props) => {
    const [{filterDrivers, loading, success}, dispatch] = useReducer(DriverListReducer, initialState);
    const [openCASDialog, setOpenCASDialog] = useState(false);
    const onClickCASButton = useCallback(() => setOpenCASDialog(true), []);
    const [checked, setChecked] = useState(driverDetailInitialState);
    const [query, setQuery] = useState("")
    const featureStatusMap = (useFeatures([FeatureConstants.VIRTUAL_DEPART_STORE_ENABLED]))[1]
    const isVirtualDepartStoreEnabled = featureStatusMap && featureStatusMap[FeatureConstants.VIRTUAL_DEPART_STORE_ENABLED] ?
        featureStatusMap[FeatureConstants.VIRTUAL_DEPART_STORE_ENABLED] : false;
    // config to check whether to show store data or not
    const actualDriverSize = isVirtualDepartStoreEnabled ? filterDrivers :
        filterDrivers.filter(packages => packages.IS_STORE === false);

    const [currentPage, setCurrentPage] = useState(1);
    const pageCount = Math.ceil(actualDriverSize.length/PAGE_SIZE);

    const currentPagePackages = actualDriverSize
        .slice( (currentPage - 1)*PAGE_SIZE, currentPage*PAGE_SIZE );

    useEffect(() => {
        const filters = props.filters;
        dispatch({
            type: "LOAD_DATA",
            data: {filters, dispatcher: dispatch}
        })
    }, []);

    useEffect(() => {
        dispatch({
            type: "FILTER_DATA",
            data: {prefix: query}
        })
        setCurrentPage(1)
    }, [query]);

    const onCheckChanged = (key) => {
        setChecked({
            driverName: currentPagePackages[key].DRIVER_NAME,
            driverId: currentPagePackages[key].DRIVER_ID,
            isStore: currentPagePackages[key].IS_STORE,
            storeId: currentPagePackages[key].STORE_ID
        });
    };

    const isCheckedRow = (index) => {
        return checked.driverId === currentPagePackages[index].DRIVER_ID;
    };

    const onSubmit = () => {
        dispatch({
            type: "FILTER_DATA",
            data: {prefix: query}
        })
        setCurrentPage(1)
    };

    if (loading) {
        return (<Row alignmentHorizontal="center" alignmentVertical="center" height="100%" minHeight="460px">
            <Loader type="circular"/>
        </Row>)
    }
    if (!success) {
        return (<Row alignmentHorizontal="center" alignmentVertical="center" height="100%" minHeight="460px">
            <Alert type="error"></Alert>
        </Row>)
    }
    return (
        <VirtualDepartDriverContextProvider>
        <Column spacingInset="small large">
            <Box>
                <Row width="100%" widths="fill" spacing="medium" spacingInset="medium">
                    <Column>
                        <Text type="h600"><FormattedMessage id="print.driver_list" defaultMessage="Driver List"/></Text>
                    </Column>
                    <Column>
                        <Row alignmentHorizontal="right">
                            <Button onClick={onClickCASButton} disabled={checked.driverId === ""} type="tertiary">
                                <FormattedMessage id="virtual.depart.driver_button" defaultMessage="Depart Driver"/></Button>
                        </Row>
                    </Column>
                </Row>
                <Row width="100%" widths="fill" spacingInset="small">
                    <Column>
                        <Text type="h200">This virtual depart is only for C-Return packages.</Text>
                    </Column>
                </Row>
                <Box>
                    <SearchField
                        value={query}
                        onChange={setQuery}
                        placeholder="Search for driver..."
                        onSubmit={onSubmit}
                        clearButton={true}
                    />
                    <Table headerRows={0} spacing="small">
                        {currentPagePackages.map((item, index) => (
                            <TableRow key={item.DRIVER_ID}>
                                <TableCell>
                                    <RadioButton checked={isCheckedRow(index)} onChange={(e) => onCheckChanged(index, e)}/>
                                </TableCell>
                                {
                                    DRIVER_ATTRIBUTES.map(([a, b], index) => {
                                        return (<TableCell key={index}>{item[a]}</TableCell>);
                                    })
                                }
                            </TableRow>
                        ))}
                    </Table>
                </Box>
                {openCASDialog && <VirtualDepartDriverDialog isModalOpen={openCASDialog} onModelOpenChange={setOpenCASDialog}
                                                             checkedDriver={checked}/>}

                <Row width="100%" widths="fill" >
                    <Box>
                        <Text type="b200" >
                            Showing { Math.min((currentPage - 1)*PAGE_SIZE + 1 , actualDriverSize.length)} to {Math.min((currentPage - 1)*PAGE_SIZE + PAGE_SIZE, actualDriverSize.length)} of {actualDriverSize.length}
                        </Text>
                    </Box>
                    <Row alignmentHorizontal="right" >
                        { (pageCount > 1) && <Pagination
                            numberOfPages={pageCount}
                            onChange={ (e) => {
                                setChecked([]);
                                setCurrentPage(e)
                            }}
                            currentPage={currentPage}
                        />
                        }
                    </Row>
                </Row>
            </Box>
        </Column>
        </VirtualDepartDriverContextProvider>
    )
};


// WEBPACK FOOTER //
// ./src/components/virtualDepartDriver/VirtualDepartDriver.js